import PaymentStatusInfoItem from './PaymentStatusInfoItem';

export default PaymentStatusInfoItem;
